import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic, {filterWrapperBasicAllSelectionsId as allSelectionsId} from '@adv-mt/mt-filter-wrapper-basic'
import Select, {formSelectSizes} from '@adv-mt/mt-form-select'

import {IMAGE_SRC_BY_CATEGORY_ID, IMAGE_SRC_BY_CATEGORY2_ID} from './config.js'

const LEGACY_WRAPPER = 'legacy'

const FormSelectCategory = ({
  initialSearch = {},
  onChange,
  overlayContentRef,
  showLabel = true,
  pageName = '',
  type,
  value = 0,
  withLabel = true,
  wrapper = LEGACY_WRAPPER
}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const {FILTER_NAMES, CATEGORY2_MAP} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')
  const {DEFAULT_CATEGORY2_ID} = config.get('searchFilters')

  const {categoryId} = initialSearch
  const options = CATEGORY2_MAP[categoryId]
  const hasOptions = Boolean(options?.length)

  const placeholder = i18n.t('COMMON.ALL_FEM')

  if (!hasOptions) return <></>

  const _handleOnChange = (e, {value}) =>
    onChange(e, {
      field: FILTER_NAMES.CATEGORY_2,
      value,
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.CATEGORY_2]
    })

  const handleChange = ({value}) => {
    const [selectedValue] = value
    _handleOnChange(null, {value: selectedValue === allSelectionsId ? DEFAULT_CATEGORY2_ID : Number(selectedValue)})
  }

  const _getLocalizedOptions = () =>
    options.map(option => ({
      ...option,
      imageSrc: IMAGE_SRC_BY_CATEGORY2_ID[option.id],
      label: i18n.t(option.label)
    }))

  const {
    0: {id: defaultValue}
  } = options

  const localizedOptions = _getLocalizedOptions()

  if (wrapper === LEGACY_WRAPPER) {
    return (
      <Select
        {...(showLabel && {label: i18n.t('CATEGORY_2_DEFAULT')})}
        field={FILTER_NAMES.CATEGORY_2}
        initialSearch={initialSearch}
        onChange={_handleOnChange}
        options={localizedOptions}
        placeholder={placeholder}
        overlayContentRef={overlayContentRef}
        pageName={pageName}
        size={formSelectSizes.LARGE}
        value={value || defaultValue}
      />
    )
  }

  return (
    <FilterWrapperBasic
      filters={[
        {
          allSelectionsImageSrc: IMAGE_SRC_BY_CATEGORY_ID[categoryId],
          allSelectionsLabel: i18n.t('COMMON.ALL'),
          name: FILTER_NAMES.CATEGORY_2,
          options: localizedOptions,
          type
        }
      ]}
      group={`${FILTER_NAMES.CATEGORY_2}Group`}
      legend={withLabel && i18n.t('CATEGORY_2_DEFAULT')}
      onChange={handleChange}
      overlayContentRef={overlayContentRef}
      showLegend={showLabel}
      value={{[FILTER_NAMES.CATEGORY_2]: [value || allSelectionsId]}}
      placeholder={value ? localizedOptions.find(({id}) => id === value)?.label : i18n.t('COMMON.TYPE')}
      wrapper={wrapper}
    />
  )
}

FormSelectCategory.displayName = 'FormSelectCategory'
FormSelectCategory.propTypes = {
  initialSearch: PropTypes.shape({
    categoryId: PropTypes.number
  }),
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  pageName: PropTypes.string,
  showLabel: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.number,
  withLabel: PropTypes.bool,
  wrapper: PropTypes.string
}

export default FormSelectCategory
